import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import ReviewsOutlinedIcon from "@mui/icons-material/ReviewsOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

import ROUTE_NAMES from "routes/routeNames";

export type SideBarIcon = OverridableComponent<SvgIconTypeMap>;

export type SideBarItem = {
  id: string;
  title: string;
  url: string;
  Icon: SideBarIcon;
};

export type SideBarSection = {
  id: string;
  label: string;
  items: SideBarItem[];
};

const SIDE_BAR_SECTIONS: SideBarSection[] = [
  {
    id: "overview",
    label: "Overview",
    items: [
      {
        id: "dashboard",
        title: "Dashboard",
        url: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD,
        Icon: SpaceDashboardOutlinedIcon,
      },
    ],
  },
  {
    id: "operations",
    label: "Operations",
    items: [
      {
        id: "user-management",
        title: "User Management",
        url: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.BASE,
        Icon: GroupsOutlinedIcon,
      },
      {
        id: "order_management",
        title: "Order Management",
        url: ROUTE_NAMES.MAIN_ROUTES.ORDER,
        Icon: ReceiptLongOutlinedIcon,
      },
    ],
  },
  {
    id: "catalog",
    label: "Catalog",
    items: [
      {
        id: "utilities-management",
        title: "Utilities Management",
        url: ROUTE_NAMES.MAIN_ROUTES.UTILITY_MANAGEMENT,
        Icon: CategoryOutlinedIcon,
      },
      {
        id: "service-management",
        title: "Service Management",
        url: ROUTE_NAMES.MAIN_ROUTES.SERVICE_MANAGEMENT,
        Icon: CleaningServicesOutlinedIcon,
      },
      {
        id: "service-pricing-management",
        title: "Service Pricing Management",
        url: ROUTE_NAMES.MAIN_ROUTES.SERVICE_PRICING_MANAGEMENT,
        Icon: PaymentsOutlinedIcon,
      },
      {
        id: "companies",
        title: "Companies",
        url: ROUTE_NAMES.MAIN_ROUTES.COMPANIES,
        Icon: ApartmentOutlinedIcon,
      },
      {
        id: "vehicle",
        title: "Vehicle",
        url: ROUTE_NAMES.MAIN_ROUTES.VEHICLE,
        Icon: DirectionsCarOutlinedIcon,
      },
    ],
  },
  {
    id: "engagement",
    label: "Engagement",
    items: [
      {
        id: "testimonial",
        title: "Testimonial",
        url: ROUTE_NAMES.MAIN_ROUTES.TESTIMONIAL,
        Icon: ReviewsOutlinedIcon,
      },
      {
        id: "coupon",
        title: "Coupon",
        url: ROUTE_NAMES.MAIN_ROUTES.COUPON,
        Icon: LocalOfferOutlinedIcon,
      },
      {
        id: "feedback",
        title: "Feedback",
        url: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
        Icon: ForumOutlinedIcon,
      },
    ],
  },
];

export default SIDE_BAR_SECTIONS;
